import { InputBase } from "@mui/material";

function ShareLinkRow({ shareLink }) {
    return (
        <InputBase
            value={shareLink}
            readOnly
            sx={{
                flexGrow: 1,
                width: "100%",
                px: 1,
                py: 0.5,
                background: "#d7d7d7",
                borderRadius: 1,
                overflowX: "auto",
                whiteSpace: "nowrap",
            }}
        />
    );
}

export default ShareLinkRow;
